const COMPONENT_NAME = "PillBadges";
const INVALID_PROPS_ERROR = `${COMPONENT_NAME}-error: Missing required parameter`;
const PAGE_TYPES = ["Search", "Product Detail", "Category"];
export {
  COMPONENT_NAME,
  INVALID_PROPS_ERROR,
  PAGE_TYPES
};
